<template>
  <div class="quotation-base-info">
    <el-descriptions :column="3">
      <el-descriptions-item :labelStyle="{'color': '#FFFFFF'}">
        <SupplierNameStatus :outsidePlugin="outsidePlugin" :info="info" :haveStatus="haveHistory" class="SupplierNameStatus" />
      </el-descriptions-item>
      <el-descriptions-item v-if="info.businessType === 'SPARE_PART'" label="供应商类型">{{ info.supplierType || '--' }}</el-descriptions-item>
      <el-descriptions-item label="报价单号">
        <div>
          <span>{{ info.code }}</span>
          <template v-if="haveHistory && info.versionNo * 1 > 1">
            / <span @click="showHistoryQuotation" style="color: #3CA0F6;cursor: pointer;">{{ info.versionNo }}</span>
            <el-tooltip
              effect="dark"
              placement="bottom-end"
              :content="`第${info.versionNo}轮报价，点击可查看历史报价`"
              >
              <i class="el-icon-question" style="color:#B0B4BD; margin-left:5px;font-size: 14px;"></i>
            </el-tooltip>
          </template>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="报价时间">{{ formatter(info.createTime, 'YYYY-MM-DD HH:mm:ss') }}</el-descriptions-item>
      <el-descriptions-item label="交付方式">{{ info.deliveryMethodDesc || '--' }}</el-descriptions-item>
      <el-descriptions-item :label="info.businessType === 'MAINTAIN' ? '计划上门时间' : '计划交付时间'">{{ formatter(info.plannedDeliveryDate, info.businessType === 'MAINTAIN' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD') }}</el-descriptions-item>
      <el-descriptions-item label="报价总额">
        <b>{{ info.totalAmount || '--' }}</b>
      </el-descriptions-item>
      <el-descriptions-item label="创建人">{{ info.createUserName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">{{ info.contactPhone || '--' }}</el-descriptions-item>
      <el-descriptions-item v-if="info.businessType === 'MAINTAIN'" label="是否含备用机">{{ info.containSpareMachineFlag ? '包含' : '不包含' }}</el-descriptions-item>
      <el-descriptions-item v-if="info.businessType === 'MAINTAIN'" label="保修期">{{ info.warrantyPeriod ? info.warrantyPeriod + info.warrantyPeriodUnitName : '--' }}</el-descriptions-item>
      <el-descriptions-item label="付款方式">{{ info.paymentMethodDesc || getPaymentMethod(info.paymentMethod) || '--' }}</el-descriptions-item>
      <el-descriptions-item label="发票类型">{{ info.invoiceTypeDesc || '--' }}</el-descriptions-item>
      <el-descriptions-item label="税率">{{ `${ info.taxRate ? (info.taxRate * 100).toFixed(0)+'%' : '--' }` }}</el-descriptions-item>
      <el-descriptions-item label="报价备注" :span="3">{{ info.quotePriceRemark || '--' }}</el-descriptions-item>
      <el-descriptions-item label="报价附件" :span="3">
        <template v-if="info.inquireQuotePriceAnnexList && info.inquireQuotePriceAnnexList.length">
          <el-link v-for="i in info.inquireQuotePriceAnnexList" :href="encodeURI(i.url)" :key="i.id" target="_blank" style="margin-right: 0.5em;" type="primary">
            {{ i.url.split('/').pop() }}
          </el-link>
        </template>
      </el-descriptions-item>
      <el-descriptions-item v-if="info.businessType === 'MAINTAIN'" label="检测结果" :span="3">{{ info.detectionResult || '--' }}</el-descriptions-item>
    </el-descriptions>

    <!-- 历史报价 -->
    <QuotationHistory ref="QuotationHistory" />
  </div>
</template>
<script>
import { dateFormat } from '@/utils/dateFormat';
import QuotationHistory from './quotationHistory.vue';
import SupplierNameStatus from './supplierNameStatus.vue';
export default {
  props: {
    haveHistory: {
      type: Boolean,
      default: true,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    outsidePlugin: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    QuotationHistory,
    SupplierNameStatus,
  },
  methods: {
    formatter (v, format) {
      return v * 1 ? dateFormat(v).format(format) : '--';
    },
    getPaymentMethod (v) {
      switch (v) {
      case '1':
        return '货到付款';
      case '2':
        return '预付款';
      case '3':
        return '票到付款';
      case '4':
        return '账期付款';
      default:
        return '';
      }
    },
    showHistoryQuotation () {
      this.$refs.QuotationHistory.inquirePriceId = this.info.inquirePriceId; // 询价单id
      this.$refs.QuotationHistory.tenantId = this.info.tenantId; // 供应商id
      this.$refs.QuotationHistory.queryHistoryQuotePriceList();
      this.$refs.QuotationHistory.showDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.quotation-base-info {
  .SupplierNameStatus {
    width: 400px;
  }
  .detail-title-box {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    &.outside-plugin {
      padding: 10px;
      padding-left: 5px;
    }
    .detail-title {
      font-weight: bold;
      font-size: 16px;
      color: #111111;
      margin: 0 4px;
      overflow: hidden;
      max-width: 280px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .common-library {
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #96CEFF;
      font-size: 12px;
      color: #237FFA;
      padding: 2px 4px;
      margin: 0 4px;
    }
    .quotation-status {
      font-size: 12px;
      padding: 4px 6px;
      margin: 0 4px;
      &.orange {
        color: #E6A23C;
        background-color: rgba(230, 162, 60, .1);
      }
      &.green {
        color: #67C23A;
        background-color: rgba(103, 194, 58, .1);
      }
      &.grey {
        color: #909399;
        background-color: rgba(144, 147, 153, .1);
      }
      &.red {
        color: #FF5959;
        background-color: rgba(255, 89, 89, .1);
      }
    }
  }
}
</style>
